module.exports = __webpack_public_path__ + "static/media/man-smiling.0f9cc351.svg";